import { useEffect, useState, useCallback } from "react";
import { EyeOff, Eye } from "lucide-react";
import api from "@/lib/api";
import AdminShell from "@/components/AdminShell";

export default function AdminReplies() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("published");

  const load = useCallback(() => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (status) p.set("status", status);
    api.get(`/admin/replies?${p.toString()}`).then((r) => setRows(r.data)).catch(() => {});
  }, [q, status]);

  useEffect(() => { load(); }, [load]);

  const setStat = async (r, s) => { await api.post(`/admin/replies/${r.reply_id}/status`, { status: s }); load(); };

  return (
    <AdminShell active="replies" title="Replies" subtitle="Search and hide replies across the forum.">
      <div className="flex flex-wrap gap-3 mb-5">
        <input data-testid="rep-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search reply text…"
          className="flex-1 min-w-[220px] rounded-full border border-rose/40 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal/40" />
        <select data-testid="rep-status" value={status} onChange={(e) => setStatus(e.target.value)}
          className="rounded-full border border-rose/40 px-4 py-2.5 text-sm bg-white">
          <option value="published">Published</option>
          <option value="hidden">Hidden</option>
          <option value="pending">Pending</option>
        </select>
      </div>

      <div className="space-y-3" data-testid="rep-list">
        {rows.length === 0 && <p className="text-mutedplum">No replies found.</p>}
        {rows.map((r) => (
          <div key={r.reply_id} className="rounded-2xl bg-white border border-rose/30 p-4" data-testid={`rep-${r.reply_id}`}>
            <p className="text-xs text-mutedplum">by {r.author_name} · on “{r.thread_title || "—"}”</p>
            <p className="mt-1 text-sm text-plum-ink/85">{r.body}</p>
            <div className="mt-3">
              {r.status === "hidden" ? (
                <button onClick={() => setStat(r, "published")} data-testid={`rep-show-${r.reply_id}`} className="inline-flex items-center gap-1.5 rounded-full bg-teal px-3 py-1.5 text-xs font-semibold text-white"><Eye className="h-3.5 w-3.5" /> Restore</button>
              ) : (
                <button onClick={() => setStat(r, "hidden")} data-testid={`rep-hide-${r.reply_id}`} className="inline-flex items-center gap-1.5 rounded-full border border-rose/50 px-3 py-1.5 text-xs font-semibold text-plum hover:bg-rose-soft"><EyeOff className="h-3.5 w-3.5" /> Hide</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </AdminShell>
  );
}
